import {FmlxButton, FmlxCard} from 'fmlx-common-ui';
import React from 'react';
import SkeletonCard from './SkeletonCard';

const SimpleCard = ({data, loaderElement ,className, loading}) => {
  const {dataFormated, heading, actions }= data;
  return (
    <div className={className}>
    {loading ? 
      (loaderElement ? React.cloneElement(
        ...loaderElement.props,
        {className: 'loader'}
        ) : <SkeletonCard data={data}/>
        ) : (
        <FmlxCard>
          <FmlxCard.Body className="text-center" variant={FmlxCard.Variant.OUTLINED}>
            <h5 className="mt-4 mb-2">{heading}</h5>
            <h2 className="mb-2">{dataFormated}</h2>
            <div className="mt-4">
              {actions &&
                actions.map((action, index) => (
                  <FmlxButton
                    key={index}
                    variant={FmlxButton.Variant.OUTLINE}
                    type={FmlxButton.Type.SECONDARY}
                    label={action.label}
                    onClick={action.onClick}
                  />
                ))}
            </div>
          </FmlxCard.Body>
        </FmlxCard>
    )}
    </div>
  );
};
export default SimpleCard;
